/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react'
import { Col, Form, Row } from 'react-bootstrap'
import { FormattedMessage, useIntl } from 'react-intl'
import { useSelector } from 'react-redux'
import { getSelectedCustomer } from '../../../../_augmentt/selectors/customers'
import { ModalPanel, ModalSidebar } from '../../../components/ModalSidebar'
import GenericConfirmationModal from './GenericConfirmationModal'

import { createHubTask, pollTaskStatus } from '../../../crud/integrationHub.crud'
import { TASK_ACTIONS, TASK_TYPES } from '../../../util/hub-task-management/hub.constants'
import { getEmployeeFullName } from '../../../util/table.util'

function RevokeSessionsModal(props) {
  const { show, onHide, onUpdate, employee, onBack } = props
  const intl = useIntl()

  // Global state
  const currentUser = useSelector(({ user }) => user.data)
  const selectedIntegration = useSelector(({ integrations }) => integrations.selectedIntegration)
  const selectedCustomer = useSelector(getSelectedCustomer)

  // Local state
  const [modalConfirmShow, setModalConfirmShow] = useState(false)

  const [isError, setError] = useState(false)
  const [status, setStatus] = useState()
  const [isLoading, setLoading] = useState(true)

  const disableLoading = () => {
    setLoading(false)
  }

  useEffect(() => {
    if (show) {
      // eslint-disable-next-line no-use-before-define
      signOutAllApps()
    }
  }, [show]) // eslint-disable-line react-hooks/exhaustive-deps

  const enableLoading = () => {
    setLoading(true)
  }

  /**
   * Sign out
   */
  async function signOutAllApps() {
    const parameters = {
      employeeIdentifier: employee?.employeeIdentifier,
    }

    enableLoading()

    const hubTask = {
      actions: parameters,
      tasktype: TASK_TYPES.revokeSessions,
      action: TASK_ACTIONS.update,
      customerId: selectedCustomer?.id,
      userId: currentUser?.id,
      organizationId: selectedCustomer?.organization,
    }

    try {
      const { data: { taskId } = {} } = await createHubTask(hubTask)

      if (taskId) {
        const { data: { _source: task } = {} } =
          (await pollTaskStatus(taskId, {
            retries: 10,
            timeout: 3000,
          })) ?? {}

        const result = {
          Status: task?.status === 'SUCCESS' ? 'Completed' : 'Failed',
          StatusMessage: task?.status === 'FAILED' ? task?.errors : '',
        }

        if (task?.errors) {
          setError(true)
          setStatus(result)
        } else {
          setStatus(result)
          onUpdate()
        }

        disableLoading()
      }
    } catch (error) {
      setError(true)
      setStatus(error)
      disableLoading()
    }
  }

  const hide = () => {
    onHide()
    setStatus()
    setError(false)
  }

  const modalConfirmHide = () => {
    setModalConfirmShow(false)
  }

  const titleId = status !== 'Completed' ? 'ENGAGE.SIGN_OUT_ALL_APPS' : 'ENGAGE.SIGNED_OUT_ALL_APPS'
  const subTitles = [
    getEmployeeFullName(employee),
    selectedIntegration?.IntegrationApplication?.display_name === 'M365'
      ? 'Microsoft 365'
      : selectedIntegration?.IntegrationApplication?.display_name,
  ].filter(Boolean)

  return (
    <>
      <ModalSidebar
        show={show}
        onHide={hide}
        size="md"
        title={titleId}
        subTitles={subTitles}
        isLoading={isLoading}
        headerBackButtonAction={onBack}
      >
        <ModalPanel leftButton="close">
          <Form>
            {isLoading && (
              <Row>
                <Col sm="12" md="12" lg="12">
                  <div className="centered">
                    <p className="font-lg font-bolder font-color-2">
                      <FormattedMessage id="ENGAGE.SIGNING_OUT_ALL_APPS" />
                    </p>
                  </div>
                </Col>
              </Row>
            )}
            {!isLoading && isError && (
              <Row>
                <Col sm="12" md="12" lg="12">
                  <span className="icon-lg font-color-danger fas fa-circle-xmark" />
                  <span className="ms-3">
                    <FormattedMessage id="ENGAGE.SIGN_OUT_ALL_APPS" />
                  </span>
                  <p className="font-color-danger" style={{ marginLeft: '2.5rem' }}>
                    {status?.StatusMessage ? status?.StatusMessage : intl.formatMessage({ id: 'GENERAL.ERROR' })}
                  </p>
                </Col>
              </Row>
            )}
            {!isLoading && !isError && status && (
              <Row>
                <Col sm="12" md="12" lg="12">
                  <span className="icon-lg font-color-engage fas fa-circle-check" />
                  <span className="ms-3">
                    <FormattedMessage id="ENGAGE.SIGN_OUT_ALL_APPS" />
                  </span>
                </Col>
              </Row>
            )}
          </Form>
        </ModalPanel>
      </ModalSidebar>

      <GenericConfirmationModal
        show={modalConfirmShow}
        title={<FormattedMessage id="GENERAL.ARE_YOU_SURE" />}
        message={<FormattedMessage id="GENERAL.ARE_YOU_SURE_3" />}
        primaryButton={{
          variant: 'primary',
          text: intl.formatMessage({ id: 'GENERAL.NO_TAKE_ME_BACK' }),
        }}
        secondaryButton={{
          variant: 'light',
          text: intl.formatMessage({ id: 'GENERAL.YES_CANCEL_ACTION' }),
        }}
        onHide={() => {
          //  Do something...
        }}
        onSubmit={modalConfirmHide}
      />
    </>
  )
}

export default RevokeSessionsModal
